import React, { useState, useEffect, useRef } from 'react';

const TagInput = ({ tags, onChange, suggestions = [] }) => {
    const [inputVisible, setInputVisible] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef(null);

    useEffect(() => {
        if (inputVisible && inputRef.current) {
            inputRef.current.focus();
        }
    }, [inputVisible]);

    const handleClose = (removedTag) => {
        const newTags = tags.filter(tag => tag !== removedTag);
        onChange(newTags);
    };

    const showInput = () => {
        setInputVisible(true);
    };

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    const handleInputConfirm = () => {
        if (inputValue && tags.indexOf(inputValue) === -1) {
            onChange([...tags, inputValue]);
        }
        setInputVisible(false);
        setInputValue('');
    };

    const handleSelect = (e) => {
        const val = e.target.value;
        if (val && tags.indexOf(val) === -1) {
            onChange([...tags, val]);
        }
        // Reset select
        e.target.value = "";
    }

    return (
        <div className="tag-input-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', alignItems: 'center' }}>
            {tags.map((tag, index) => {
                const isLongTag = tag.length > 20;
                const tagElem = (
                    <span key={tag} className="tag" style={{ display: 'inline-flex', alignItems: 'center', background: '#fafafa', border: '1px solid #d9d9d9', borderRadius: '2px', padding: '0 7px', fontSize: '12px', height: '22px' }}>
                        {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                        <span
                            onClick={(e) => { e.stopPropagation(); handleClose(tag); }}
                            style={{ marginLeft: '4px', cursor: 'pointer', color: '#999', fontSize: '10px' }}
                        >×</span>
                    </span>
                );
                return tagElem;
            })}

            {inputVisible && (
                <input
                    ref={inputRef}
                    type="text"
                    size="small"
                    style={{ width: '78px', height: '22px', fontSize: '12px', padding: '0 5px', border: '1px solid #d9d9d9', borderRadius: '2px' }}
                    value={inputValue}
                    onChange={handleInputChange}
                    onBlur={handleInputConfirm}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') handleInputConfirm();
                    }}
                />
            )}

            {!inputVisible && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <button
                        onClick={showInput}
                        style={{ background: 'none', border: '1px dashed #d9d9d9', cursor: 'pointer', padding: '0 7px', height: '22px', fontSize: '12px', borderRadius: '2px', color: '#666' }}
                    >
                        + New Tag
                    </button>
                    {suggestions.length > 0 && (
                        <select
                            style={{ marginLeft: '5px', height: '22px', border: 'none', background: 'transparent', width: '20px', cursor: 'pointer' }}
                            onChange={handleSelect}
                            value=""
                            title="选择已有标签"
                        >
                            <option value="" disabled>▼</option>
                            {suggestions.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
                        </select>
                    )}
                </div>

            )}
        </div>
    );
};

export default TagInput;
